<template>
  <div id='myApp' class='gPageBorder' v-loading='loading'>

    <el-dialog  :title="dialogConfig.tip" :visible.sync="dialogTopMgVisible" style='text-align:center' size=tiny>
      <el-button style='width:20%;' @click='processRecommend(0)'>{{$t('app_no')}}</el-button>
      <el-button type='primary' style='margin-left:20%;width:20%;' @click='processRecommend(1)'>{{$t('app_yes')}}</el-button>
    </el-dialog>

    <el-row>
      <el-col :span='8'>
        <el-button :disabled="isAdmin" class='gSgLeftBtn' type="primary" @click="showAddApp">{{$t('app_addApp')}}</el-button>
        <el-button :disabled="isAdmin" @click='allUndercarriage' >{{$t('app_mulOffShelf')}} ({{sNum}})</el-button>
      </el-col>
      <el-col :span='4'>
        <div style='width:100%;height:10px;'></div>
      </el-col>
      <el-col :span='4' >
        <div class='gCtrl'>
          <MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
        </div>
      </el-col>
      <el-col :span='4' >
        <div class='gCtrl'>
          <!-- <el-select  v-model="appType" clearable :placeholder="$t('app_type')" @change='selectChange'>
            <el-option
              v-for="item in appTypes"
              :key="item.appClassifyId"
              :label="item.appClassifyName"
              :value="item.appClassifyId">
            </el-option>
          </el-select> apptypes-->

          <el-cascader
            expand-trigger="hover"
            :options="appTypes"
            clearable=""
            @change='selectChange'
            :show-all-levels="false"
            v-model="appType"
          ></el-cascader>
        </div>
      </el-col>

      <el-col :span='4'>
        <div class='gSideCtrl'><el-input  :placeholder="$t('app_appName')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div>
      </el-col>
    </el-row>



    <div >
      <el-table
      class='tbPoint gTopMg'
      @row-click='cellClick'
	    ref="multipleTable"
	    :data="tableData"
	    border
      @sort-change="sortChange"
	    tooltip-effect="dark"
	    style="width: 100%"
	    @selection-change="handleSelectionChange">
  	    <el-table-column
          align=center
  	      type="selection"
  	      width="55">
  	    </el-table-column>
  	    <el-table-column
          align=center
          sortable="custom"
  	      prop='appName'
  	      :label="$t('app_appName')"
  	      width="">
  	    </el-table-column>
  	    <el-table-column
          align='center'
  	      prop="appCategoryName"
  	      :label="$t('app_type')"
  	      width="">
  	    </el-table-column>
        <el-table-column
          align='center'
  	      prop="distributorName"
  	      :label="$t('app_distributor')"
  	      width="">
  	    </el-table-column>
  	    <!-- <el-table-column
          align=center
  	      prop="appInstallType"
  	      :label="$t('app_insType')"
  	      width='100'>
          <template slot-scope='scope'>
            <el-label>{{setInstallType(scope.row.appInstallType)}}</el-label>
          </template>
  	    </el-table-column> -->
        <el-table-column
          align=center
          prop=""
          :label="$t('app_classIntrol')"
          width=''>
          <template slot-scope='scope'>
            <el-button type='text' v-if="scope.row.isType === '0'" @click='classRecommend(scope.row, scope)'>{{$t('app_yes')}}</el-button>
            <el-button type='text' v-else @click='classRecommend(scope.row, scope)'>{{$t('app_no')}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          align=center
          prop=""
          :label="$t('app_homeIntrol')"
          width=''>
          <template slot-scope='scope'>
            <el-button type='text' v-if="scope.row.isHome === '0'" @click='homeRecommend(scope.row, scope)'>{{$t('app_yes')}}</el-button>
            <el-button type='text' v-else @click='homeRecommend(scope.row, scope)'>{{$t('app_no')}}</el-button>
          </template>
        </el-table-column>
  	    <el-table-column
          align=center
  	      prop="createTime"
          sortable="custom"
          :formatter="dateFormat"
  	      :label="$t('app_ulTime')"
  	      width='175'>
  	    </el-table-column>
  	    <el-table-column
  	      prop="appVersion"
          align=center
  	      :label="$t('app_newgVer')"
  	      width=''>
  	    </el-table-column>
  	    <el-table-column
  	      prop="operate"
          align=center
  	      :label="$t('app_operate')"
  	      width='106'>
  	      <template slot-scope='scope'>
  	        <!-- <el-button @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button>
  	        <el-button @click='undercarriage(scope.row)' type=text>{{$t('app_offShelf')}}</el-button> -->

            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload" style=""></i></el-button>
            </el-tooltip> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_offShelf')" placement="top">
              <el-button type='text' @click='undercarriage(scope.row)'><i class="fa fa-arrow-circle-o-down" style=""></i></el-button>
            </el-tooltip>

  	      </template>
  	    </el-table-column>
  	  </el-table>
    </div>

    <div class="gPgDiv" >

      <el-pagination
        class='gPg'
        @current-change="pageSelect"
        @size-change="pageSized"
        :current-page="index"
        :page-sizes='$gRows'
        :page-size="row"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
  </div>
</template>

<style>
  html body{background:white;margin:0;padding:0}
  #myApp{background:none;overflow:hidden;}

    #maAdd{overflow:hidden;margin-top:20px;}
    #maAdd button{}

    #maTable{margin-top:20px;margin-left:0px;margin-right:0px;}

    #maPage{overflow:hidden;background:none;margin-top:10px;}
      #maPage div{float:right;margin-right:0px;}


</style>

<script>
  import mm from 'moment'
  // import addApp from '@/components/app/my/AddApp'
  // import lang from '@/components/language/app'
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    data () {
      return {
        isAdmin: this.$getWObj().login.userType == 0,
        mechanismData: '',
        orderName: '',
        orderType: '',
        sNum: 0,
        mechanismId: window.localStorage['mechanismId'],
        mechId: window.localStorage['mechanismId'],
        loading: 0,
        queryKey: '',
        appType: '',
        appTypes: [],
        tableData: [],
        multipleSelection: [],
        total: 0,
        page: 1,
        dialogTopMgVisible: 0,
        dialogConfig: {tip: '', data: '', type: ''},
        selectAll: {}
      }
    },
    components: {MechanismSelector},
    computed: {
      index () {
        return this.$getWPage('appMarketPage')
      }
    },
    methods: {
      sortChange (vl) {
        switch (vl.prop) {
          case 'appName':
            this.orderName = '1'
            break
          case 'createTime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
      setInstallType (type) {
        return this.$installType[type]
      },
      query () {
        this.getList()
      },
      reset () {
        this.queryKey = ''
        this.appType = ''
        this.getList()
      },
      selectChange (vl) {
        this.getList()
      },
      getTypeList (mcid) {
        this.$gpAppType(mcid, (res) => {
          if (res.data.length > 0) {
            this.appTypes = res.data[0].children
          }
        }, '')
        /*this.$getAppTypeList(100000000, 1, (res) => {
          if (res.status === 200) {
            // console.log(res)
            this.appTypes = res.data
          } else {
            this.$message(res.message)
          }
        }, '')*/
      },
      cellClick (row, ev, col) {
        if (col.label && col.label !== this.$t('app_operate') && col.label !== this.$t('app_classIntrol') && col.label !== this.$t('app_homeIntrol')) {
          // console.log(row)
          this.$setWObj("appDisplay", {appid:row.applicationid, isMk: true})
          // /appSlot/view
          //this.$router.push({name: this.$t('menu.appManageSub.viewApp')})
          this.$router.push({path: '/appSlot/view'})
        }
      },
      dateFormat (row, column) {
        var date = row[column.property]
        if (date === undefined) {
          return ''
        }
        return mm(date).format('YYYY-MM-DD HH:mm:ss')
      },
      pageSelect (index) {
        this.$setWPage('appMarketPage', index)
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      toggleSelection (rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row)
          })
        } else {
          this.$refs.multipleTable.clearSelection()
        }
      },
      processRecommend (yes) {
        this.dialogTopMgVisible = 0
        var config = this.dialogConfig
        switch(config.type) {
          case 'class':
            this.loading = 1
            var typeId = config.data.appCategoryId
            // var vl = yes ? typeId : ''
            var vl = yes ? '0' : '1'
            if (this.$appUrlTag === 0) {
              this.$recommendClass(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  var tm = config.data
                  tm.isType = vl
                  this.tableData[config.index] = tm
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                this.loading = 0
              })
            } else {
              this.$recommendClass1(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status === 200) {
                  var tm = config.data
                  tm.isType = vl
                  this.tableData[config.index] = tm
                } else {
                  this.$message.error(res.message)
                }
              }, () => {
                this.loading = 0
              })
            }

            break
          case 'home':
            this.loading = 1
            // var vl = yes ? '1' : '0'
            var vl = yes ? '0' : '1'
            if (this.$appUrlTag === 0) {
              this.$recommendHome(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status !== 200) {
                  this.$message.error(res.message)
                } else {
                  var tm = config.data
                  tm.isHome = vl
                  this.tableData[config.index] = tm
                }
              }, () => {
                this.loading = 0
              })
            } else {
              this.$recommendHome1(this.mechanismId, config.data.applicationid, vl, (res) => {
                this.loading = 0
                if (res.status !== 200) {
                  this.$message.error(res.message)
                } else {
                  var tm = config.data
                  tm.isHome = vl
                  this.tableData[config.index] = tm
                }
              }, () => {
                this.loading = 0
              })
            }

            break
        }
      },
      classRecommend (row, scope) {
        this.dialogTopMgVisible = 1
        this.dialogConfig = {type: 'class', data: row, tip: this.$t('app_isIntroClass'), index: scope.$index}
      },
      homeRecommend (row, scope) {
        this.dialogTopMgVisible = 1
        this.dialogConfig = {type: 'home', data: row, tip: this.$t('app_isIntroHome'), index: scope.$index}
      },
      undercarriage (row) {

        // console.log(row)
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffShelf'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          if (this.$appUrlTag === 0) {
            this.$appDistributeOnOff(this.mechanismId, row.packagename, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getList()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          } else {
            this.$appDistributeOnOff1(this.mechanismId, row.packagename, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getList()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          }

        }, '')

      },
      allUndercarriage () {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isOffApp'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          var ids = ''
          this.multipleSelection.forEach((vl) => {
            ids += vl.packagename + ','
          })
          ids = ids.substring(0, ids.length - 1)
          // console.log(ids)
          if (!ids) {
            this.$message(this.$t('app_chooseOneMust'))
            return
          }
          this.loading = 1
          if (this.$appUrlTag === 0) {
            this.$appDistributeOnOff(this.mechanismId, ids, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getList()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          } else {
            this.$appDistributeOnOff1(this.mechanismId, ids, '1', (res) => {
              if (res.status === 200) {
                // this.$message.success(res.message)
                this.getList()
              } else {
                this.$message.error(res.message)
              }
              this.loading = 0
            }, () => {
              // error
              this.loading = 0
            })
          }

        }, '')

      },
      handleSelectionChange (val) {
        this.sNum = val.length
        this.multipleSelection = val


      },
      showAddApp () {
        // /appSlot/distribute-add
        //this.$router.push({name: this.$t('menu.appManageSub.custom')})
        this.$router.push({path: '/appSlot/distribute-add'})
      },
      bindOperate (obj) {
        //console.log(obj)
        //return
        //this.$setWObj('appBindInfo', {data: obj, type: 1})
        //this.$router.push({name: this.$t('menu.appManageSub.customPush')})
        this.$setWObj('pushList', {data: obj, type: '1'})
        this.$router.push({path: '/appslot/distribute-push'})
      },
      selected (rows) {
        /* rows.forEach(row => {
          console.log('e', row)
          this.$refs.multipleTable.toggleRowSelection(row);
        }) */
      },
      getList (isGetType) {
        this.loading = 1
        var sName = this.queryKey ? this.queryKey : ''
        var sCid = this.appType.length > 0 ? this.appType[0] : ''

        var mcid = this.mechId?this.mechId:this.mechanismId

        if (isGetType) {
          this.getTypeList(mcid)
        }

        this.$getDistributeAppList1(sName, sCid, this.$gRow, this.$getWPage('appMarketPage'), mcid, this.orderName, this.orderType, (res) => {
          console.log(res)
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
            // console.log('tbd', res.data)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
          // error
        })


      }
    },
    mounted () {
      var _this = this
      this.mechanismData = {
        callback (value) {
          _this.mechId = value
          _this.getList(true)
        }
      }
      this.getList(true)
    }
  }
</script>



// WEBPACK FOOTER //
// slot.vue?29f135d1